import { instrumentMethod } from '@datadog/browser-core';
import { IncrementalSource } from '../../../types';
import { getSerializedNodeId, hasSerializedNode } from '../serialization';
import { assembleIncrementalSnapshot } from '../assembly';
export function trackStyleSheet(styleSheetCb) {
  function checkStyleSheetAndCallback(styleSheet, callback) {
    if (styleSheet && hasSerializedNode(styleSheet.ownerNode)) {
      callback(getSerializedNodeId(styleSheet.ownerNode));
    }
  }
  const instrumentationStoppers = [instrumentMethod(CSSStyleSheet.prototype, 'insertRule', ({
    target: styleSheet,
    parameters: [rule, index]
  }) => {
    checkStyleSheetAndCallback(styleSheet, id => styleSheetCb(assembleIncrementalSnapshot(IncrementalSource.StyleSheetRule, {
      id,
      adds: [{
        rule,
        index
      }]
    })));
  }), instrumentMethod(CSSStyleSheet.prototype, 'deleteRule', ({
    target: styleSheet,
    parameters: [index]
  }) => {
    checkStyleSheetAndCallback(styleSheet, id => styleSheetCb(assembleIncrementalSnapshot(IncrementalSource.StyleSheetRule, {
      id,
      removes: [{
        index
      }]
    })));
  })];
  if (typeof CSSGroupingRule !== 'undefined') {
    instrumentGroupingCSSRuleClass(CSSGroupingRule);
  } else {
    instrumentGroupingCSSRuleClass(CSSMediaRule);
    instrumentGroupingCSSRuleClass(CSSSupportsRule);
  }
  function instrumentGroupingCSSRuleClass(cls) {
    instrumentationStoppers.push(instrumentMethod(cls.prototype, 'insertRule', ({
      target: styleSheet,
      parameters: [rule, index]
    }) => {
      checkStyleSheetAndCallback(styleSheet.parentStyleSheet, id => {
        const path = getPathToNestedCSSRule(styleSheet);
        if (path) {
          path.push(index || 0);
          styleSheetCb(assembleIncrementalSnapshot(IncrementalSource.StyleSheetRule, {
            id,
            adds: [{
              rule,
              index: path
            }]
          }));
        }
      });
    }), instrumentMethod(cls.prototype, 'deleteRule', ({
      target: styleSheet,
      parameters: [index]
    }) => {
      checkStyleSheetAndCallback(styleSheet.parentStyleSheet, id => {
        const path = getPathToNestedCSSRule(styleSheet);
        if (path) {
          path.push(index);
          styleSheetCb(assembleIncrementalSnapshot(IncrementalSource.StyleSheetRule, {
            id,
            removes: [{
              index: path
            }]
          }));
        }
      });
    }));
  }
  return {
    stop: () => {
      instrumentationStoppers.forEach(stopper => stopper.stop());
    }
  };
}
export function getPathToNestedCSSRule(rule) {
  const path = [];
  let currentRule = rule;
  while (currentRule.parentRule) {
    const rules = Array.from(currentRule.parentRule.cssRules);
    const index = rules.indexOf(currentRule);
    path.unshift(index);
    currentRule = currentRule.parentRule;
  }
  // A rule may not be attached to a stylesheet
  if (!currentRule.parentStyleSheet) {
    return;
  }
  const rules = Array.from(currentRule.parentStyleSheet.cssRules);
  const index = rules.indexOf(currentRule);
  path.unshift(index);
  return path;
}
